export const UPDATESUBMENU = 'UPDATESUBMENU'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js